import React, { Dispatch } from 'react';
import { Modal } from 'reactstrap';
import { IState } from '../../models/components/lesson-upcoming-activity';
import { IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { IApplyForumPostProps } from '../../models/components/apply-forum-post';

class ApplyPost extends React.Component<IApplyForumPostProps> {

    public onSubmit = () => {
        //
    }
    public onClose = () => {
        this.props.isClose();
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} className={'modal-open-reactstrap'}>
                <Formik
                    initialValues={{}}
                    // validationSchema={getValidation}
                    onSubmit={this.onSubmit}
                    // tslint:disable-next-line
                    render={props => (
                        <form onSubmit={props.handleSubmit}>
                            <div className="modal-from-right add-announcement">
                                <div >
                                    <div >
                                        <div className="modal-header">
                                            <h5 className="modal-title">Moderasyon Bekleyen Mesajlar/Yorumlar</h5>
                                            <button type="button" className="close" onClick={this.onClose}>
                                                <i className="material-icons">close</i>
                                                <span>ESC</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="forum-content">
                                                <div className="title">
                                                    Converter Ipod Video Taking Portable Video Viewing To A Whole New Level
                                </div>
                                                <div className="desc d-inline pull-left">
                                                    <span>Mehmet Çelik</span> tarafından <span>2 Saat önce</span>
                                                </div>
                                                <div className="option">
                                                    <img src="/dots.svg" className="m-t-15" alt="Dots" />
                                                </div>
                                                <div className="clear" />
                                                <div className="text border-bottom">
                                                    <span>It won’t be a bigger problem to find one video game lover in your neighbor. Since the introduction of Virtual Game, it has been achieving great heights so far as its popularity and technological advancement are concerned. The history of video game is as interesting as a fairy tale. The quality of today’s video game was not at all there when video game first conceptualized and played ever.</span>
                                                    <div className="col-md text-md-right">
                                                        <button type="button" className="btn2 btn-gray mt-md-0 mt-2 mb-md-0 mb-2" style={{ marginRight: '4px' }}><i className="material-icons">clear</i>Reddet</button>
                                                        <button type="button" className="btn2 btn-green"> <i className="material-icons">arrow_forward</i>Onayla</button>
                                                    </div>
                                                </div>

                                                <div className="desc d-inline pull-left">
                                                    <span>Mehmet Çelik</span> tarafından <span>2 Saat önce</span>
                                                </div>
                                                <div className="option">
                                                    <img src="/dots.svg" className="m-t-15" alt="Dots" />
                                                </div>
                                                <div className="clear" />
                                                <div className="text border-bottom">
                                                    <span>It won’t be a bigger problem to find one video game lover in your neighbor. Since the introduction of Virtual Game, it has been achieving great heights so far as its popularity and technological advancement are concerned. The history of video game is as interesting as a fairy tale. The quality of today’s video game was not at all there when video game first conceptualized and played ever.</span>
                                                    <div className="col-md text-md-right">
                                                        <button type="button" className="btn2 btn-gray mt-md-0 mt-2 mb-md-0 mb-2" style={{ marginRight: '4px' }}><i className="material-icons">clear</i>Reddet</button>
                                                        <button type="button" className="btn2 btn-green"> <i className="material-icons">arrow_forward</i>Onayla</button>
                                                    </div>
                                                </div>


                                                <div className="desc">
                                                    Matematik Analiz 1 / İstatistik İÖ.
                                    </div>
                                                <div className="title">
                                                    Ödev takımının sorumlukları
                                    </div>
                                                <div className="desc d-inline pull-left">
                                                    <span>Mehmet Çelik</span> tarafından <span>2 Saat önce</span>
                                                </div>
                                                <div className="option">
                                                    <img src="/dots.svg" className="m-t-15" alt="Dots" />
                                                </div>
                                                <div className="clear" />
                                                <div className="text border-bottom">
                                                    <span>It won’t be a bigger problem to find one video game lover in your neighbor. Since the introduction of Virtual Game, it has been achieving great heights so far as its popularity and technological advancement are concerned. The history of video game is as interesting as a fairy tale. The quality of today’s video game was not at all there when video game first conceptualized and played ever.</span>
                                                    <div className="col-md text-md-right">
                                                        <button type="button" className="btn2 btn-gray mt-md-0 mt-2 mb-md-0 mb-2" style={{ marginRight: '4px' }}><i className="material-icons">clear</i>Reddet</button>
                                                        <button type="button" className="btn2 btn-green"> <i className="material-icons">arrow_forward</i>Onayla</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="modal-footer d-block">
                                            <div className="row">
                                                <div className="col-md">
                                                    <button type="button" className="btn btn-gray" onClick={this.onClose}>İptal</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    )}
                />

            </Modal>
        );
    }
}

const mapStateToProps = (state: IState, ownProps: IApplyForumPostProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IApplyForumPostProps = Object.assign({}, ownProps, {

    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CApplyPost = connect(mapStateToProps,
    dispatchProps,
)(ApplyPost);

export default CApplyPost;